<template>
  <a-modal title="Edit" :visible="modal.visible" :confirm-loading="modal.confirmLoading" @ok="submit" @cancel="hide">
    <a-form :form="form">
      <a-form-item label="DefaultValue">
        <a-input
          v-decorator="['defaultValue',{rules:[{required:true,message:'Rulecannot be empty'},{pattern:/^(?:true|false|(?:\[missing]|\[&quot;.*&quot;]|[(\[](?:-Inf|missing|-?\d+(?:.\d+)?),(?:Inf|missing|-?\d+(?:.\d+)?)[)\]])(?:U(?:\[missing]|\[&quot;.*&quot;]|[(\[](?:-Inf|missing|-?\d+(?:.\d+)?),(?:Inf|missing|-?\d+(?:.\d+)?)[)\]]))*)$/,message:'Rule Format Error'}]}]"></a-input>
      </a-form-item>
    </a-form>
    <div>
      true True Value (Must Be Used Independently)<br/>
      false False Value (Must Be Used Independently)<br/>
      [missing] Null<br/>
      ["some string with"] Single String<br/>
      [-Inf,Inf] Positive/Negative Infinity, Open/Closed Space OK<br/>
      [missing,missing] Null Equivalent to Positive/Negative Infinity<br/>
      [float,float] Closed Interval<br/>
      (float,float) Open Interval<br/>
      Multiple Interval UseUCombine, e.g.:[-Inf,1)U[2,missing)
    </div>
  </a-modal>
</template>
<script>
import {updateRiskFeature} from "@/webpublicapi/risk";

export default {
  name: 'VariableEditModal',
  data() {
    return {
      modal: {
        visible: false,
        confirmLoading: false,
      },
      form: this.$form.createForm(this),
      model: {id: undefined}
    }
  },
  methods: {
    show({id, defaultValue} = {}) {
      if (!id) {
        this.$message.error('IDError')
        return
      }
      this.form = this.$form.createForm(this, {
        mapPropsToFields: () => {
          return {
            defaultValue: this.$form.createFormField({value: defaultValue}),
          }
        }
      })
      this.modal.visible = true
      this.model = {id}
    },
    hide() {
      this.modal.visible = false
      this.model = {id: undefined}
    },
    submit() {
      this.form.validateFields((errors, values) => {
        if (!errors) {
          this.modal.confirmLoading = true
          updateRiskFeature(Object.assign({}, this.model, values)).then(() => {
            this.$message.success(this.$t('success'))
            this.$emit('success')
            this.hide()
          }).catch(({message}) => {
            this.$message.error(message)
          }).finally(() => {
            this.modal.confirmLoading = false
          })
        }
      })
    }
  }
}
</script>